import { Grid, Typography } from '@mui/material';

import { DisplayCurrency } from 'src/components';

interface CommissionStatProps {
    label: string;
    value: number;
    usersCurrency: string;
}

const CommissionStat = ({ label, value, usersCurrency }: CommissionStatProps) => {
    return (
        <Grid
            md={6}
            sx={{
                display: 'flex',
                placeItems: 'center',
                flexDirection: 'column',
            }}
        >
            <Typography data-testid="commission-stat-label">{label}</Typography>
            <Grid
                sx={{ display: 'flex', flexDirection: 'row', padding: '4px' }}
                alignItems="center"
                gap={1}
            >
                <DisplayCurrency
                    centsAmount={value}
                    style={{ fontSize: '24px', fontWeight: 500, color: '#575757' }}
                    usersCurrency={usersCurrency}
                />
            </Grid>
        </Grid>
    );
};
export default CommissionStat;
